module.exports = __webpack_public_path__ + "static/media/learn2.428e768d.jpg";